import { Box, Text, Image } from "@chakra-ui/react";
import background from "../assets/bg.jpg";
import Menubar from "../components/Menubar";
import tsujigettan from "../assets/tsujigettan.jpg";
import ippojitsumugai from "../assets/ippojitsumugai.png";
import { ACCENT_1_COLOR } from "../constants/color";
import { useTranslation } from "react-i18next";
import { Helmet } from "react-helmet-async";

export default function TsujiGettan() {
  const {t} = useTranslation();

  const schemaMarkup = {
    "@context": "https://schema.org",
    "@type": "AboutPage",
    "mainEntity": {
      "@type": "Person",
      "name": "Tsuji Gettan Sukemochi",
      "birthDate": "1648",
      "deathDate": "1727",
      "description": "Master pedang legendaris dan samurai yang mendirikan aliran Mugai Ryu setelah mencapai pencerahan Zen pada tahun 1693."
    }
  };

  return (
    <Box
      display={"flex"}
      width={"100vw"}
      background={`transparent url(${background})`}
      bgRepeat={"repeat"}
      pb={"24px"}
    >
      <Helmet>
        <title>{t("tsujiGetanTitle")}</title>
        <meta name="description" content={t("tsujiGetanDesc")} />
        <link rel="canonical" href="https://mugairyu-indonesia.com/tsuji-gettan" />
        
        <script type="application/ld+json">
          {JSON.stringify(schemaMarkup)}
        </script>
      </Helmet>
      <Box
        width={"100vw"}
        height={"auto"}
      >
        <Menubar />
        <Box
          width={"100vw"}
          px={{ base: "5vw", lg: "20vw" }}
          display={"flex"}
          flexDir={"column"}
          textAlign={"left"}
          mt={"18px"}
        >
          <Text textColor={ACCENT_1_COLOR} fontSize={"30px"}>
          Tsuji Gettan Sukemochi
          </Text>
          <Text
            textColor={"#765946"}
            fontStyle={"italic"}
            fontSize={"18px"}
            mb={"24px"}
          >
            {t("tsujiGettanSubtitle")}
          </Text>
          
          <Image src={tsujigettan} w={"100%"} mb={"24px"}></Image>

          <Text mb={"18px"}>
            {t("tsujiGettan1")}
          </Text>

          <Text mb={"18px"}>
            {t("tsujiGettan2")}
          </Text>

          <Text mb={"18px"}>
            {t("tsujiGettan3")}
          </Text>

          <Text mb={"18px"}>
            {t("mugaiRyu4")}
          </Text>
          <Text fontStyle={"italic"} mb={"12px"}>
            {t("mugaiRyu5")} <br /> {t("mugaiRyu6")} <br /> {t("mugaiRyu7")}{" "}
            <br /> {t("mugaiRyu8")}
          </Text>

          <Image src={ippojitsumugai} w={"100%"} mb={"24px"}></Image>

          <Text fontStyle={"italic"} mb={"18px"}>
            {t("mugaiRyu9")} <br />
            {t("mugaiRyu10")} <br />
            {t("mugaiRyu11")} <br />
            {t("mugaiRyu12")} <br />
            {t("mugaiRyu13")}
          </Text>

          <Text mb={"18px"}>
            {t("tsujiGettan4")}
          </Text>

          <Text mb={"18px"}>
            {t("tsujiGettan5")}
          </Text>

          <Text mb={"18px"}>
            {t("tsujiGettan6")}
          </Text>

          <Text mb={"18px"}>
            {t("tsujiGettan7")}
          </Text>

          <Text mb={"18px"}>
            {t("tsujiGettan8")}
          </Text>

          <Text mb={"18px"}>
            {t("tsujiGettan9")}
          </Text>

          <Text>
            {t("tsujiGettan10")}
          </Text>
        </Box>
      </Box>
    </Box>
  );
}
